import React from "react";
import FormularioRD from "../rdstation/formularioRD";
import { useModal } from "../contexts/ModalContext";

export default function ResgatamosProjetos() {
    const { openModal } = useModal();
    return (
        <div className="w-full bg-[#040116] py-12 md:py-20 px-8 md:px-12 flex flex-col items-center justify-center">
            <div className="max-w-[1000px] text-center space-y-8">
                <h2 className="text-transparent bg-clip-text bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] text-2xl md:text-[38px] font-inter-semibold leading-[1.4] md:leading-[1.2]">
                    Resgatamos projetos de desenvolvimento de software{" "}
                    <span className="font-inter-regular text-white">
                        com nossa expertise técnica e abordagem estratégica,
                        garantindo sua recuperação e entrega qualificada.
                    </span>
                </h2>
                <p className="font-inter-regular text-sm md:text-[22px] text-white">
                    Apoiamos empresas a reposicionar suas soluções no mercado,
                    garantindo resultados
                    sólidos, sustentáveis e que gerem retorno sobre o
                    investimento.
                </p>
                <div className="flex justify-center w-full pt-4">
                    <button
                        onClick={() => openModal(<FormularioRD />)}
                        className="font-inter-regular flex items-center gap-2.5 rounded-full py-3 md:py-2 px-8 md:px-12 text-sm w-fit cursor-pointer hover:scale-105 transition-transform duration-200 border border-[#A002CB] bg-white"
                    >
                        <span className="bg-gradient-to-r from-[#A002CB] to-[#4B3BDB] bg-clip-text text-transparent">
                            Recupere seus projetos
                        </span>
                    </button>
                </div>
            </div>
        </div>
    );
}
